// src/components/video/script/video.js

;(function () {
    window.Ateed.Components.Video = function($container) {

        $('.ateed-video-thumbnail').click(function () {
            var $thumb = $(this);
            var $video = $(this).next();
            var videoUrl = '';
            var updateQueryStringParameter = function (uri, key, value) {
                var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
                var separator = uri.indexOf('?') !== -1 ? '&' : '?';
                if (uri.match(re)) {
                    return uri.replace(re, '$1' + key + '=' + value + '$2');
                }
                else {
                    return uri + separator + key + '=' + value;
                }
            }

            // Toggle thumbnail image and,
            // video player.
            $thumb.css({
                'height': 0,
                'opacity': 0
            });
            $video.show();

            if ($video.find('video').get(0)) {
                $video.find('video').get(0).play();
            }
            else {
                videoUrl = $video.find('iframe').attr('src');
                $video
                    .find('iframe')
                    .attr(
                        'src',
                        updateQueryStringParameter(videoUrl, 'autoplay', 1)
                    );
            }
        })
    }
})();
